import React, { useRef } from 'react';
import { Survey } from 'survey-react-ui';
import { mySurveyJson } from './surveyJson';
import { Model as SurveyModel } from 'survey-core';
import 'survey-core/survey-core.min.css';

function InstallSurvey() {
  const survey = new SurveyModel(mySurveyJson);
  const responseHistory = useRef<any[]>([]);

  // Track every change
  survey.onValueChanged.add((sender, options) => {
    responseHistory.current.push({
      questionName: options.name,
      value: options.value,
      allData: { ...sender.data },
      timestamp: new Date().toISOString()
    });
  });

  survey.onComplete.add(async (sender, options) => {
    try {
      await fetch('http://localhost:3004/api/survey', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: sender.data, // final answers
          surveyJson: mySurveyJson,
          responseHistory: responseHistory.current // all intermediate answers
        })
      });
      alert('Thank you! Your responses have been submitted.');
    } catch (error) {
      console.error('Error submitting survey:', error);
      alert('There was an error submitting your responses. Please try again.');
    }
  });

  return <Survey model={survey} />;
}

export default InstallSurvey;